<template>
    <v-card
        class="ma-0 pa-3"
        height="433"
    >
        <v-container
            class="pa-0 d-flex justify-space-between"
        >
            <div>
                <div class="d-flex align-center gap-1">
                    <v-card-text class="pa-0 text-body-1">
                        {{ $store.state.currency.name }}
                        {{ $numberFormat(sumOfSells) }}
                    </v-card-text>
                    <!-- <v-chip
                        text-color="white"
                        x-small
                    >
                    <div class="d-flex align-center gap-1">
                        <span>2.5%</span>
                        <svg width="12" height="6" viewBox="0 0 12 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.78516 0.5H10.6423V3.35714" stroke="#137333" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M10.6412 0.5L6.60547 4.53571C6.53871 4.60115 6.44895 4.63781 6.35547 4.63781C6.26199 4.63781 6.17223 4.60115 6.10547 4.53571L4.46261 2.89286C4.39585 2.82742 4.3061 2.79077 4.21261 2.79077C4.11913 2.79077 4.02937 2.82742 3.96261 2.89286L1.35547 5.5" stroke="#137333" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                    </v-chip> -->
                </div>
                <v-card-text class="pa-0 text-caption mt-1">{{ $t('sale-by-product') }}</v-card-text>
            </div>
            <div class="d-flex gap-2">
                <!-- <v-select
                    :items="items"
                    label="یک هفته گذشته"
                    dense
                    outlined
                    append-icon="mdi-chevron-down"
                >
                </v-select>-->
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="secondary"
                      outlined
                      v-bind="attrs"
                      v-on="on"
                      custom
                    >
                      <svg width="17" height="17" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M6 8L3.5 5.5L4.2 4.775L5.5 6.075V2H6.5V6.075L7.8 4.775L8.5 5.5L6 8ZM3 10C2.725 10 2.48967 9.90217 2.294 9.7065C2.09833 9.51083 2.00033 9.27533 2 9V7.5H3V9H9V7.5H10V9C10 9.275 9.90217 9.5105 9.7065 9.7065C9.51083 9.9025 9.27533 10.0003 9 10H3Z" fill="#030303"/>
                      </svg>
                    </v-btn>
                  </template>
                  <v-list v-if="products != null && products != undefined && products.length > 0 && $store.getters.getpermission && $store.getters.getpermission.includes('overview')">
                    <v-list-item @click="exportChart('png')">
                      <v-list-item-title>
                        <v-card-text class="pa-0 text-body-2">{{ $t('PNG-image') }}</v-card-text>
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="exportChart('pdf')">
                      <v-list-item-title>
                        <v-card-text class="pa-0 text-body-2">{{ $t('PDF-file') }}</v-card-text>
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="exportChart('excel')">
                      <v-list-item-title>
                        <v-card-text class="pa-0 text-body-2">{{ $t('EXCEL-file') }}</v-card-text>
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
                <v-select
                  :items="items"
                  :label="$t('productCount')"
                  dense
                  outlined
                  append-icon="mdi-chevron-down"
                  item-text="name"
                  item-value="value"
                  style="width: 170px;"
                  v-model="selectedProductCount"
                  @change="selectProductCount"
                  :class="{ 'dltr' : !$vuetify.rtl}"
                  :style="{ 'direction' : !$vuetify.rtl ? 'rtl' : ''}"
                >
                </v-select>
            </div>
        </v-container>
        <div v-if="$store.getters.getpermission && $store.getters.getpermission.includes('overview')">
          <apexchart
            v-if="products != null && products != undefined && products.length > 0"
            :options="chartOptions"
            :series="chartSeries"
            height="340"
            ref="chartComponent"
          />
          <div
            v-if="products != null && products != undefined && products.length == 0 && !loading"
            style="margin-top: 100px;"
          >
            <div class="d-flex justify-center align-center">
              <img src="@/assets/dashboard/no-data(1).png" style="width: 120px;" />
            </div>
            <div class="d-flex justify-center align-center mt-5">
              <v-card-text class="pa-0 text-caption">
                {{ $t('there is no enough information for showing.') }}
              </v-card-text>
            </div>
          </div>
          <v-container
            v-if="loading"
            class="pa-0 d-flex justify-center align-center"
          >
            <v-progress-circular
              :width="3"
              color="blue"
              indeterminate
            />
          </v-container>
        </div>
        <div v-else style="margin-top: 110px;">
          <div class="d-flex justify-center align-center">
            <img src="@/assets/dashboard/not-access(1).png" style="width: 120px;" />
          </div>
          <div class="d-flex justify-center align-center mt-5">
            <v-card-text class="pa-0 text-caption text-center">
              {{ $t("you don't have access to this information") }}
            </v-card-text>
          </div>
        </div>
    </v-card>
</template>

<script>
import jsPDF from "jspdf" // PDF export
import * as XLSX from "xlsx" // Excel export

export default {
  data () {
    return {
      selectedProductCount: 1,
      items: [],
      lastPage: null,
      products: [],
      sumOfSells: null,
      loading: false,
      chartOptions: {
        dataLabels: {
          enabled: false // Disable showing values on bars
        },
        chart: {
          type: 'bar',
          height: 340,
          toolbar: {
            show: false
          },
          fontFamily: 'IRANSans'
        },
        plotOptions: {
          bar: {
            horizontal: true, // Horizontal bar chart
            columnWidth: '50%', // Adjust column width (you can modify it as needed)
            barHeight: '70%'
          }
        },
        stroke: {
          show: true
        },
        xaxis: {
          categories: [], // X-axis categories
          axisBorder: {
            show: false // Hide the X-axis line
          },
          axisTicks: {
            show: false // Hide the ticks on the X-axis
          },
          labels: {
            show: true
          },
          grid: {
            show: false
          },
          lines: {
            show: false // This removes the vertical lines
          }
        },
        yaxis: {
          labels: {
            offsetX: 0
          },
          grid: {
            show: false // Enable vertical gridlines
          }
        },
        tooltip: {
          y: {
            formatter: (val) => {
              return this.$numberFormat(val) + ' ' + this.$store.state.currency.name;
            }
          }
        },
        responsive: [{
          breakpoint: 480,
          options: {
            chart: {
              width: 400,
              height: 200,
              offsetY: 50
            },
            legend: {
              position: 'top',
              horizontalAlign: 'center'
            }
          }
        }]
      },
      chartSeries: [
        {
          name: 'Sales',
          data: []
        }
      ],
      options: {
        page: 1,
        itemsPerPage: 5,
        sortBy: [],
        sortDesc: []
      }
    }
  },
  methods: {
    fetchList () {
      if (this.products.length == 0) {
        this.loading = true
      }
      var app = this
      app.$axios.get(this.$endpoint + 'invoiceReport', {
        params: {
          select: 'typeProductItems',
          type: 'sell',
          page: this.options.page,
          options: JSON.stringify({ page: this.options.page, itemsPerPage: this.options.itemsPerPage })
        }
      })
        .then(r => {
          this.loading = false
          this.lastPage = r.data.last_page
          this.products.push(...r.data.data)
          if (this.lastPage == 1) {
            this.items.push({ name: this.$t('top-5-product'), value: 1 })
          }
          if (this.lastPage == 2) {
            this.items.push({ name: this.$t('top-5-product'), value: 1 }, { name: this.$t('top-10-product'), value: 2 })
          }
          if (this.lastPage >= 3) {
            this.items.push({ name: this.$t('top-5-product'), value: 1 }, { name: this.$t('top-10-product'), value: 2 }, { name: this.$t('top-15-product'), value: 3 })
          }
          // Update the chart options for X and Y axes
          this.chartOptions = {
            ...this.chartOptions,
            xaxis: {
              tickAmount: 4,
              categories: this.products.map(p => p.product.name),
              /*  logarithmic: true, */
              labels: {
                rotate: 0, // Keep labels horizontal
                style: {
                  fontSize: '10px'
                },
                show: true,
                formatter: (value) => {
                  return `${this.$store.state.currency.name} ${this.$numberFormat(value)}`
                }
              }
            },
            yaxis: {
              labels: {
                show: true,
                style: {
                  fontSize: '10px'
                },
                offsetX: 0
              }
            }
          }
          this.chartSeries = [
            {
              name: this.$t('sell'),
              data: this.products.map(p => parseFloat(p.amount_invoice))
            }
          ]
          this.sumOfSells = this.products.reduce((sum, item) => sum + parseFloat(item.amount_invoice), 0)
        })
        .catch(e => {
          console.error('Error:', e)
        })
        .finally(() => {
          this.loading = false
        })
    },
    selectProductCount (value) {
      this.options.page = value
      this.fetchList()
    },
    async exportChart(format) {
    const chartRef = this.$refs.chartComponent?.chart;
    if (!chartRef) {
        console.error("Chart instance not available.");
        return;
    }

    try {
        // Create a temporary chart container for export
        const tempChartContainer = document.createElement("div");
        document.body.appendChild(tempChartContainer);

        // Extract the original chart options
        const clonedOptions = {
            ...chartRef.w.config,
            chart: { 
                type: chartRef.w.config.chart.type, 
                animations: { enabled: false },
                toolbar: { show: false } // Hide the toolbar during export
            },
            xaxis: { ...chartRef.w.config.xaxis },
            yaxis: { 
                ...chartRef.w.config.yaxis,
                labels: { 
                  formatter: (val) => `${this.$numberFormat(val)} ${this.$store.state.currency.name}` 
                }
            }
        };

        const tempChart = new ApexCharts(tempChartContainer, clonedOptions);

        // Render the temporary chart
        await tempChart.render();

        // Export based on format
        if (format === "png" || format === "svg") {
            const { imgURI } = await tempChart.dataURI({
                width: 300,   // Smaller width (reduce to desired size)
                height: 200,  // Smaller height (reduce to desired size)
                scale: 0      // Scale set to 1 for regular resolution
            });
            this.downloadImage(imgURI, `chart-export.${format}`);
        } else if (format === "pdf") {
            await this.exportToPDF(tempChart);
        } else if (format === "excel") {
            await this.exportToExcel();
        }

        // Safeguard: Ensure the chart and container are removed properly
        if (tempChartContainer && tempChartContainer.parentNode) {
            try {
                tempChart.destroy();
                tempChartContainer.parentNode.removeChild(tempChartContainer);
            } catch (cleanupError) {
                console.error("Error during cleanup:", cleanupError);
            }
        }

    } catch (error) {
        console.error("Export failed:", error);
    }
    },
    // 📌 Download PNG / SVG
    downloadImage(uri, filename) {
      const link = document.createElement("a");
      link.href = uri;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    // 📌 Export to PDF (using jsPDF)
    async exportToPDF(tempChart) {
    try {
        // Generate PNG image from the chart
        const { imgURI } = await tempChart.dataURI({
            width: 600,  // Adjust the width as needed
            height: 400, // Adjust the height as needed
            scale: 1     // Normal resolution
        });

        // Create a new PDF document
        const pdf = new jsPDF({ orientation: "landscape" });

        // Add the chart image to the PDF
        pdf.addImage(imgURI, "PNG", 20, 20, 250, 140); // Adjust positioning as needed

        // Optionally, add a title or any other content to the PDF
        pdf.setFontSize(12);
        pdf.text("Chart Export", 20, 180);  // Title text
        pdf.text("Chart data and values are included below:", 20, 190);  // Subtitle

        // Optionally, you can add chart data below the image (for example)
        const chartOptions = tempChart.w.config;
        const chartSeries = chartOptions.series;
        const categories = chartOptions.xaxis.categories;

        let yPosition = 200; // Start position for chart data text
        chartSeries.forEach((series, index) => {
            pdf.text(`${series.name}:`, 20, yPosition);
            yPosition += 10;
            series.data.forEach((dataPoint, i) => {
                pdf.text(` ${categories[i]} - ${dataPoint}`, 30, yPosition);
                yPosition += 6;
            });
        });

        // Save the PDF
        pdf.save("chart-export.pdf");

    } catch (error) {
        console.error("Export to PDF failed:", error);
    }
    },


    // 📌 Export to Excel (using XLSX)
    exportToExcel() {
      if (!this.products || this.products.length === 0) {
        console.error("No data available for export.");
        return;
      }

      // Prepare data for export
      const data = [
        [this.$t('product-name'), this.$t('total-sales')],
        ...this.products.map(p => [p.product.name, p.amount_invoice])
      ];

      // Create worksheet
      const worksheet = XLSX.utils.aoa_to_sheet(data);

      // Ensure numbers are stored as text to prevent scientific notation
      data.slice(1).forEach((row, index) => {
        const cellRef = XLSX.utils.encode_cell({ r: index + 1, c: 1 });
        worksheet[cellRef].z = '@'; // Format as text
      });

      // Create workbook
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sales Report");

      // Export file
      XLSX.writeFile(workbook, "sales-report.xlsx");
    }
  },
  mounted () {
    this.fetchList()
  },
  watch: {
    selectedProductCount (val) {
      if (val == 1) {
        this.products = []
      }
    }
  }
}
</script>

<style scoped>
::v-deep .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded) > .v-input__control > .v-input__slot {
    padding: 0 4px 0 0 !important;
}
::v-deep .v-text-field--outlined.v-input--dense.v-text-field--outlined > .v-input__control > .v-input__slot {
    min-height: 32px !important;
}
::v-deep .v-label.v-label {
    font-size: 11px !important;
}
::v-deep .v-icon.v-icon {
    font-size: 15px;
}
.v-chip.v-size--x-small {
    border-radius: 4px;
}
.v-chip {
    padding: 9px 7px;
    background-color: rgb(229, 254, 237) !important;
    color: #4caf50 !important;
}
.v-card__text {
    width: auto;
}
.v-sheet.v-card:not(.v-sheet--outlined) {
    box-shadow: none !important;
}
::v-deep .v-input .v-input__control .v-label.v-label--active  {
    right: 7px !important;
}
::v-deep .v-input.dltr .v-input__control .v-label.v-label--active  {
    left: 13px !important;
}
::v-deep .apexcharts-canvas {
  direction: ltr;
}
@media (max-width: 960px) {
  ::v-deep .apexcharts-canvas ::v-deep .apexcharts-yaxis text {
    transform: rotate(338deg);
  }
  text#SvgjsText1073 {
    transform: rotate(338deg);
  }
}
</style>
